import { Grid } from "@material-ui/core";
import * as React from "react";
import { BooleanInput, NumberInput, SelectInput, TextInput } from "react-admin";
import { Form } from "react-final-form";
import { ExperienceNoteType } from "../../../../../src/Enums/ExperienceNoteType";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import { SectionTitle } from "../../../../Components/SectionTitle";
import { Separator } from "../../../../Components/Separator";
import { CarrierType, GetCarrierType } from "../../../../Enums/CarrierType";
import { PbhSvcShipmentTypeEnum } from "../../../../Enums/PbhSvcShipmentType";
import { useAppDataProvider } from "../../../../dataprovider";
import ExperienceSoftWarningDialog from "../ExperiencePopup";
import ServiceableStatusChip from "../Statu/ServiceableStatusChip";
import OrderTypesEnum from "../../../../../src/Enums/OrderTypes";
import { ServiceableStatu } from "../../../../../src/Enums/ServiceableStatus";
import { OpenInNew } from "@material-ui/icons";
import { useAuth } from "@airborne/react-admin";
import { getTkCargoTrackingUrl } from "../../../../Helper/TkCargoHelper";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const ServiceableView = props => {
  const { user } = useAuth();
  const dataProvider = useAppDataProvider();
  const [shipmentTypeList, setShipmentTypeList] = React.useState<any[]>([]);
  const [orderTypeList, setOrderTypeList] = React.useState<any[]>([]);
  React.useEffect(() => {
    GetShipmentTypeList();
    GetOrderTypeList();
  }, []);
  const GetShipmentTypeList = () => {
    dataProvider
      .getList("ParameterDefinitions", {
        pagination: { page: 1, perPage: 500 },
        sort: { field: "id", order: "DESC" },
        filter: { parameterGroupCode__eq: PbhSvcShipmentTypeEnum.PbhSvcShipmentType },
      })
      .then(result => {
        setShipmentTypeList(result?.data ?? []);
      })
      .catch(result => console.error(result));
  };
  const GetOrderTypeList = () => {
    dataProvider
      .getList("ParameterDefinitions", {
        pagination: { page: 1, perPage: 500 },
        sort: { field: "id", order: "DESC" },
        filter: { parameterGroupCode__eq: OrderTypesEnum.OrderTypes },
      })
      .then(result => {
        setOrderTypeList(result?.data ?? []);
      })
      .catch(result => console.error(result));
  };

  return (
    <>
      <Form
        initialValues={props.serviceable}
        onSubmit={e => {}}
        render={({ handleSubmit, form, values }) => (
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <Separator />
                <Grid {...gridContainerProps}>
                  <SectionTitle label="Serviceable Info" />
                  <ServiceableStatusChip serviceable={props.serviceable} />
                </Grid>
                <Separator />
                <Grid {...gridContainerProps}>
                  <Grid item xs={12} sm={5}>
                    <TextInput source="pn" label="PN" fullWidth resettable variant="outlined" disabled />
                    <TextInput source="sn" label="SN" fullWidth resettable variant="outlined" disabled />
                    <TextInput source="flightNo" label="Flight No" fullWidth resettable variant="outlined" disabled />
                    <CustomDatetime
                      fullWidth
                      source="forwardDateToCarrier"
                      label="Forward Date To Carrier"
                      inputVariant={"dialog"}
                      variant="outlined"
                      showTime
                      disabled
                    />
                    <SelectInput
                      source="shipmentType"
                      label="Shipment Type"
                      choices={shipmentTypeList}
                      optionText="parameterDesc"
                      optionValue="parameterValue"
                      fullWidth
                      variant="outlined"
                      disabled
                    />
                    {Number(props.serviceable?.shipmentType) == Number(PbhSvcShipmentTypeEnum.DropShipment) && (
                      <TextInput
                        source="orderNumber"
                        label="Order Number"
                        fullWidth
                        resettable
                        variant="outlined"
                        disabled
                      />
                    )}
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    {props.serviceable?.awb && !user?.isCustomer && (
                      <a
                        href={getTkCargoTrackingUrl(props.serviceable.awb)}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#C90C0F", textDecoration: "none", fontSize: "12px" }}
                      >
                        <OpenInNew style={{ fontSize: 12, marginRight: 4 }} />
                        Track on TK Cargo
                      </a>
                    )}
                    <TextInput source="awb" label="AWB No" fullWidth resettable variant="outlined" disabled />
                    <NumberInput
                      source="xoNo"
                      label="XO Number"
                      max={8}
                      fullWidth
                      resettable
                      variant="outlined"
                      disabled
                    />
                    <SelectInput
                      source="carrierEnum"
                      label="Carrier"
                      choices={GetCarrierType}
                      optionText="Description"
                      optionValue="Value"
                      fullWidth
                      variant="outlined"
                      disabled
                    />
                    <CustomDatetime
                      fullWidth
                      source="estimatedDeliveryDate"
                      label="Estimated Delivery Date"
                      inputVariant={"dialog"}
                      variant="outlined"
                      showTime
                      disabled
                    />
                    {Number(props.serviceable?.shipmentType) == Number(PbhSvcShipmentTypeEnum.DropShipment) && (
                      <SelectInput
                        source="orderType"
                        label="Order Type"
                        choices={orderTypeList}
                        optionText="parameterDesc"
                        optionValue="parameterValue"
                        fullWidth
                        variant="outlined"
                        disabled
                      />
                    )}
                    <BooleanInput
                      label="Received as damaged, but it will be installed on aircraft"
                      source="isCid"
                      disabled
                    />{" "}
                    {values.status === ServiceableStatu.Rejected && (
                      <TextInput source="rejectReasons" label="Reject Reasons" disabled fullWidth variant="outlined" />
                    )}
                  </Grid>
                </Grid>
                <Grid {...gridContainerProps}>
                  <Grid item xs={12} sm={5}>
                    {values.status === ServiceableStatu.Rejected && (
                      <TextInput
                        source="rejectionNote"
                        label="Rejection Note"
                        multiline
                        minRows={3}
                        fullWidth
                        disabled
                        variant="outlined"
                      />
                    )}
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    {values.isCid == true && (
                      <TextInput
                        source="cidDescription"
                        label="Cid Remark"
                        multiline
                        minRows={3}
                        fullWidth
                        disabled
                        variant="outlined"
                      />
                    )}
                  </Grid>
                </Grid>
                <Separator />
              </Grid>
            </Grid>
          </form>
        )}
      />
      <ExperienceSoftWarningDialog data={props?.requestDetail?.experience} type={ExperienceNoteType.Serviceable} />
    </>
  );
};

const PbhRequestServiceableView = props => {
  return <ServiceableView serviceable={props.serviceable} requestDetail={props.requestDetail} />;
};

export default PbhRequestServiceableView;
